import { render } from "./partners.vue?vue&type=template&id=2941af07&scoped=true"
import script from "./partners.vue?vue&type=script&lang=js"
export * from "./partners.vue?vue&type=script&lang=js"

import "./partners.vue?vue&type=style&index=0&id=2941af07&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2941af07"

export default script